import { render, staticRenderFns } from "./Link.vue?vue&type=template&id=4dffc9cc&"
import script from "./Link.vue?vue&type=script&lang=ts&"
export * from "./Link.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports